// extracted by mini-css-extract-plugin
export default {"flex":"Comparision_flex__2HHOJ","desktopSideMenu":"Comparision_desktopSideMenu__dR3xz","bottomSideMenu":"Comparision_bottomSideMenu__2VCLx"};